import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Box, Button, Icon, Text, VStack, useBreakpointValue } from "native-base";
import React from "react";

import EmptyList from "@/components/molecules/EmptyList";
import MobileHeader from "@/components/molecules/MobileHeader";
import SimpleWebHeader from "@/components/molecules/SimpleWebHeader";
import Container from "@/components/organisms/Container";

import AddressListItem from "./components/AddressListItem";
import { AddressListScreenProps } from "./types";

const AddressListWeb = ({
  addressList,
  principalAddressId,
  onBack,
  onPressCreate,
  onSelectAddress,
  onOpenAddressInfo,
}: AddressListScreenProps) => {
  const paddingX = useBreakpointValue({
    base: "1/5",
    xl: "1/4",
    "2xl": "1/3",
  });
  return (
    <Container px={paddingX} Header={<SimpleWebHeader />}>
      <Box py="4">
        <MobileHeader title="Meus endereços" showLogo={false} onBackPress={onBack} />
      </Box>
      <Button
        variant="ghost"
        rounded="lg"
        p="4"
        shadow="4"
        onPress={onPressCreate}
        leftIcon={
          <Icon as={<MaterialCommunityIcons name="map-marker" />} size="md" color="primary.600" />
        }>
        <Text color="primary.600" fontSize="md" bold>
          Adicionar novo endereço
        </Text>
      </Button>
      <VStack py="2" minH="500px">
        {addressList?.length === 0 && (
          <Box w="1/2" alignSelf="center" py="8">
            <EmptyList />
            <Text py="6" textAlign="center" fontSize="lg">
              Adicione um endereço para visualizar os melhores estabelecimentos e as melhores
              ofertas!
            </Text>
          </Box>
        )}
        {addressList?.map((item) => (
          <AddressListItem
            key={item?._id}
            active={item._id === principalAddressId}
            address={item}
            onPress={() => onSelectAddress(item)}
            onPressAddressInfo={() => onOpenAddressInfo(item)}
          />
        ))}
      </VStack>
    </Container>
  );
};

export default AddressListWeb;
